import React from "react";

// https://stackoverflow.com/questions/11442712/get-width-height-of-remote-image-from-url
export function getMeta(url, callback) {
  var img = new Image();
  img.src = url;
  img.onload = function () {
    callback(this.width, this.height);
  };
}

const ProjectHero = (props) => {
  const [background, setBackground] = React.useState(`url(${props.src})`);

  React.useEffect(() => {
    getMeta(props.src, function (width, _height) {
      if (width < 1200) {
        setBackground(undefined);
      }
    });
  }, [props.src]);

  return (
    <div
      className="project-hero"
      style={{
        width: "100vw",
        height: "100vh",
        position: "absolute",
        top: 0,
        zIndex: -1,
        backgroundImage: background,
        backgroundSize: "cover",
      }}
    ></div>
  );
};
export default ProjectHero;
